import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export function usePublicCreator(token: string) {
  return useQuery({
    queryKey: ['public-creator', token],
    queryFn: () => api.publicCreator.getByToken(token),
    enabled: !!token,
    staleTime: 5 * 60 * 1000,
  })
}

export function usePublicCreatorSales(token: string, page = 1, limit = 10) {
  return useQuery({
    queryKey: ['public-creator-sales', token, page, limit],
    queryFn: () => api.publicCreator.getSales(token, page, limit),
    enabled: !!token,
    staleTime: 2 * 60 * 1000,
  })
}

export function usePublicCreatorTiers(token: string) {
  return useQuery({
    queryKey: ['public-creator-tiers', token],
    queryFn: () => api.publicCreator.getTiers(token),
    enabled: !!token,
    staleTime: 5 * 60 * 1000,
  })
}

export function usePublicCreatorSeedings(token: string) {
  return useQuery({
    queryKey: ['public-creator-seedings', token],
    queryFn: () => api.publicCreator.getSeedings(token),
    enabled: !!token,
    staleTime: 2 * 60 * 1000,
  })
}
